var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-breadcrumbs',{attrs:{"items":_vm.bc},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("chevron_right")])]},proxy:true},{key:"item",fn:function({ item }){return [_c('text-item',{attrs:{"meta":item.meta.breadcrumb,"params":item.params,"route-name":item.name}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }